(function () {
    'use strict';

    angular
        .module('riskModule')
        .controller('grcRiskSubRisksController', Controller);

    Controller.$inject = ['$scope', 'grcRiskService'];

    function Controller($scope, grcRiskService) {

        // Get All Risk Levels
        $scope.riskLevels = [];
        grcRiskService
            .getAllRiskLevels()
            .then(function (riskLevels) {
                $scope.riskLevels = riskLevels;
            });

        $scope.getSubRiskLevel = function (parentRisk) {
            if (_.isUndefined(parentRisk)) return;
            if (!$scope.riskLevels.length) return;

            if (parentRisk.RiskLevel.IsTopRisk) return _.find($scope.riskLevels, { IsKeyRisk: true });
            if (parentRisk.RiskLevel.IsKeyRisk) return _.find($scope.riskLevels, { IsDepartmentRisk: true });
        };

    }

})();